"use strict";
/**
 * Shared domain types for AiLumix.
 * These types are consumed by the API (NestJS), the Web client (Next.js),
 * and future mobile (React Native) / desktop (Tauri) clients.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.DATA_SOURCE_LABELS = exports.DATA_SOURCE_THRESHOLDS = void 0;
/** 数据源状态阈值配置（N01：按源配置不同阈值） */
exports.DATA_SOURCE_THRESHOLDS = {
    'market.tickers': 90_000, // 实时行情：1.5 分钟无更新 = 延迟
    'market.spotTickers': 180_000, // 90s TTL ×2
    'market.externalTickers': 180_000,
    'market.overview': 300_000, // 5 分钟
    'market.derivatives': 300_000,
    'news.feed': 3_600_000, // 小时级
    'calendar.events': 43_200_000, // 日历：12 小时
    'hl.onchain': 300_000,
    'liquidation.events': 600_000, // 采集 68 币串行，放宽避免误报
};
exports.DATA_SOURCE_LABELS = {
    'market.tickers': '實時行情',
    'market.spotTickers': '多所現貨報價',
    'market.externalTickers': '外部交易所報價',
    'market.overview': '市場概覽',
    'market.derivatives': '合約衍生數據',
    'news.feed': '資訊流',
    'calendar.events': '經濟日曆',
    'hl.onchain': 'Hyperliquid 鏈上',
    'liquidation.events': '爆倉事件',
};
